
import { RESPONSIVE_VARIABLES_CHANGED_EVENT } from '~/lib/constants';
// ---- internal imports ----


function getCssVariable(variableName) {
	return window.getComputedStyle(document.documentElement)
		.getPropertyValue(variableName);
}

function removePx(cssVariableValue) {
	if (!cssVariableValue || cssVariableValue.length === 0) {
		return '';
	}

	return cssVariableValue.substr(0, cssVariableValue.length - 2);
}

function asInt(cssVariableValue) {
	return cssVariableValue.length === 0 ? 0 : parseInt(cssVariableValue);
}

function getCssVariableValue(cssVariableName) {
	return asInt(removePx(getCssVariable(cssVariableName)));
}

function getOffsetLeft() {
	return getCssVariableValue('--offsetLeft');
}

function getBlackHeight() {
	return getCssVariableValue('--blackHeight');
}

function getPeakrowHeight() {
	return getCssVariableValue('--peakrowHeight');
}

function hasPeakrow() {
	return getPeakrowHeight() > 0;
}

function getBoxedHeight() {
	return getCssVariableValue('--boxedHeight');
}

function getBoxedWidth() {
	return getCssVariableValue('--boxedWidth');
}

function getScreenScale() {
	return parseFloat(getCssVariable('--screenScale'));
}

function calculatePosition({ x = 0, y = 0 }) {
	const screenScale = getScreenScale();

	return {
		x: Math.round(x * screenScale),
		y: Math.round(y * screenScale),
	};
}

function calculateSize({ width = 0, height = 0 }) {
	const screenScale = getScreenScale();

	return {
		width: Math.round(width * screenScale),
		height: Math.round(height * screenScale),
	};
}

function calculateFontSize(fontSize) {
	return Math.round(fontSize * getScreenScale());
}

function getDraggingBounds(draggableElementSize = {}) {
	const { width = 0, height = 0 } = draggableElementSize;

	return {
		top: -1 * getPeakrowHeight(),
		left: 0,
		right: getBoxedWidth() - width,
		bottom: getBoxedHeight() - height,
	};
}

function creatScreenResponsivityChangeEvent() {
	return new CustomEvent(RESPONSIVE_VARIABLES_CHANGED_EVENT);
}

export {
	getOffsetLeft,
	getBlackHeight,
	getPeakrowHeight,
	hasPeakrow,
	getBoxedHeight,
	getBoxedWidth,
	getScreenScale,
	calculatePosition,
	calculateSize,
	calculateFontSize,
	getDraggingBounds,
	creatScreenResponsivityChangeEvent,
};
